import moment from 'moment';
import { UNITE } from '@/configuration/devisConf';

export default function genererLiaisonTarifFromProduitAssocie(
  produitAssocie, periode,
) {
  let infoProduitAssocie = produitAssocie.produitDivers;
  if (produitAssocie.produitLocation) infoProduitAssocie = produitAssocie.produitLocation;
  const liaison = {
    produitEnfantId: produitAssocie.id,
    produitEnfant: produitAssocie,
    libelle: produitAssocie.libelle,
    liaisonsTarif: [],
    uniteVente: infoProduitAssocie ? infoProduitAssocie.uniteVente : UNITE,
    quantite: infoProduitAssocie ? infoProduitAssocie.quantite : 0,
    prixUnitaire: infoProduitAssocie ? infoProduitAssocie.prixUnitaire : 0,
    dateDebut: null,
    dateFin: null,
  };
  if (periode) {
    liaison.dateDebut = new Date(periode.dateDebut);
    liaison.dateFin = new Date(periode.dateFin);
    liaison.liaisonsTarif = produitAssocie.liaisonsTarif.filter((l) => {
      return moment(liaison.dateDebut).isBetween(moment(l.dateDebut), moment(l.dateFin),
        'day', '[]');
    });
  }
  return liaison;
}
